module.exports = __webpack_public_path__ + "public/images/icon-youtube.6baafc4bff74c9346659f85b8922fc57.svg";